import { gql } from '@apollo/client';

export const ALL_PORTAL_ATTENDEES = gql`
  query AllPortalAttendees($input: AttendeesFilter!) {
    attendees: allPortalAttendees(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          firstName
          lastName
          emailAddress
          attendeeStartDate
          attendeeEndDate
          cohorts {
            id
            name
          }
          institutions {
            id
            name
            emisNumber
          }
          primaryInstitution {
            id
            name
            emisNumber
          }
          associatedInstitutions {
            id
            startDate
            endDate
            institution {
              id
              name
            }
          }
          grades {
            id
            value
            name
          }
          sessions {
            id
            name
            activity {
              id
              interventions {
                id
                fromDate
                toDate
              }
            }
            activityTarget {
              id
              cohort {
                id
                name
              }
              institution {
                id
                name
              }
            }
          }
          type {
            id
            name
          }
        }
        cursor
      }
    }
  }
`;
